import { default as _91_46_46_46path_93nLxE2vRayPMeta } from "/vercel/path0/pages/[...path].vue?macro=true";
import { default as indexe9Brt5DfdhMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as _91item_93mWMJC6qcyIMeta } from "/vercel/path0/pages/points-de-vue/[item].vue?macro=true";
import { default as indexxotlLpKSjEMeta } from "/vercel/path0/pages/points-de-vue/index.vue?macro=true";
import { default as points_45de_45vueHWs7QaOFhMMeta } from "/vercel/path0/pages/points-de-vue.vue?macro=true";
import { default as _91item_93hUnT4hG9KeMeta } from "/vercel/path0/pages/realisations/[item].vue?macro=true";
import { default as indexj85t6b1gVbMeta } from "/vercel/path0/pages/realisations/index.vue?macro=true";
import { default as realisations1fA9EuhBycMeta } from "/vercel/path0/pages/realisations.vue?macro=true";
import { default as _91item_93isajXVnSleMeta } from "/vercel/path0/pages/savoir-faire/[item].vue?macro=true";
import { default as indexTGzOI3jWblMeta } from "/vercel/path0/pages/savoir-faire/index.vue?macro=true";
import { default as savoir_45fairebBwPlb4LstMeta } from "/vercel/path0/pages/savoir-faire.vue?macro=true";
export default [
  {
    name: _91_46_46_46path_93nLxE2vRayPMeta?.name ?? "path",
    path: _91_46_46_46path_93nLxE2vRayPMeta?.path ?? "/:path(.*)*",
    meta: _91_46_46_46path_93nLxE2vRayPMeta || {},
    alias: _91_46_46_46path_93nLxE2vRayPMeta?.alias || [],
    redirect: _91_46_46_46path_93nLxE2vRayPMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/[...path].vue").then(m => m.default || m)
  },
  {
    name: indexe9Brt5DfdhMeta?.name ?? "index",
    path: indexe9Brt5DfdhMeta?.path ?? "/",
    meta: indexe9Brt5DfdhMeta || {},
    alias: indexe9Brt5DfdhMeta?.alias || [],
    redirect: indexe9Brt5DfdhMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/index.vue").then(m => m.default || m)
  },
  {
    path: points_45de_45vueHWs7QaOFhMMeta?.path ?? "/points-de-vue",
    children: [
  {
    name: _91item_93mWMJC6qcyIMeta?.name ?? "points-de-vue-item",
    path: _91item_93mWMJC6qcyIMeta?.path ?? ":item()",
    meta: _91item_93mWMJC6qcyIMeta || {},
    alias: _91item_93mWMJC6qcyIMeta?.alias || [],
    redirect: _91item_93mWMJC6qcyIMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/points-de-vue/[item].vue").then(m => m.default || m)
  },
  {
    name: indexxotlLpKSjEMeta?.name ?? "points-de-vue",
    path: indexxotlLpKSjEMeta?.path ?? "",
    meta: indexxotlLpKSjEMeta || {},
    alias: indexxotlLpKSjEMeta?.alias || [],
    redirect: indexxotlLpKSjEMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/points-de-vue/index.vue").then(m => m.default || m)
  }
],
    name: points_45de_45vueHWs7QaOFhMMeta?.name ?? undefined,
    meta: points_45de_45vueHWs7QaOFhMMeta || {},
    alias: points_45de_45vueHWs7QaOFhMMeta?.alias || [],
    redirect: points_45de_45vueHWs7QaOFhMMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/points-de-vue.vue").then(m => m.default || m)
  },
  {
    path: realisations1fA9EuhBycMeta?.path ?? "/realisations",
    children: [
  {
    name: _91item_93hUnT4hG9KeMeta?.name ?? "realisations-item",
    path: _91item_93hUnT4hG9KeMeta?.path ?? ":item()",
    meta: _91item_93hUnT4hG9KeMeta || {},
    alias: _91item_93hUnT4hG9KeMeta?.alias || [],
    redirect: _91item_93hUnT4hG9KeMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/realisations/[item].vue").then(m => m.default || m)
  },
  {
    name: indexj85t6b1gVbMeta?.name ?? "realisations",
    path: indexj85t6b1gVbMeta?.path ?? "",
    meta: indexj85t6b1gVbMeta || {},
    alias: indexj85t6b1gVbMeta?.alias || [],
    redirect: indexj85t6b1gVbMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/realisations/index.vue").then(m => m.default || m)
  }
],
    name: realisations1fA9EuhBycMeta?.name ?? undefined,
    meta: realisations1fA9EuhBycMeta || {},
    alias: realisations1fA9EuhBycMeta?.alias || [],
    redirect: realisations1fA9EuhBycMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/realisations.vue").then(m => m.default || m)
  },
  {
    path: savoir_45fairebBwPlb4LstMeta?.path ?? "/savoir-faire",
    children: [
  {
    name: _91item_93isajXVnSleMeta?.name ?? "savoir-faire-item",
    path: _91item_93isajXVnSleMeta?.path ?? ":item()",
    meta: _91item_93isajXVnSleMeta || {},
    alias: _91item_93isajXVnSleMeta?.alias || [],
    redirect: _91item_93isajXVnSleMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/savoir-faire/[item].vue").then(m => m.default || m)
  },
  {
    name: indexTGzOI3jWblMeta?.name ?? "savoir-faire",
    path: indexTGzOI3jWblMeta?.path ?? "",
    meta: indexTGzOI3jWblMeta || {},
    alias: indexTGzOI3jWblMeta?.alias || [],
    redirect: indexTGzOI3jWblMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/savoir-faire/index.vue").then(m => m.default || m)
  }
],
    name: savoir_45fairebBwPlb4LstMeta?.name ?? undefined,
    meta: savoir_45fairebBwPlb4LstMeta || {},
    alias: savoir_45fairebBwPlb4LstMeta?.alias || [],
    redirect: savoir_45fairebBwPlb4LstMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/savoir-faire.vue").then(m => m.default || m)
  }
]